import { useMemo } from 'react';
import { useAuth } from '../utils/AuthContext';
import {
  getFirstAllowedPath,
  getModuleForPath,
  MODULE_LABELS,
  resolvePermissions,
} from '../config/tenantPermissions';

export const usePermissions = () => {
  const { user } = useAuth();

  const permissions = useMemo(() => resolvePermissions(user), [user]);

  const can = (module) => permissions.includes(module);

  const canAccessPath = (pathname) => {
    const module = getModuleForPath(pathname);
    if (!module) return false;
    return can(module);
  };

  const firstAllowedPath = useMemo(
    () => getFirstAllowedPath(permissions),
    [permissions]
  );

  const allowedModuleLabels = useMemo(
    () => permissions.map((key) => MODULE_LABELS[key]).filter(Boolean),
    [permissions]
  );

  return {
    permissions,
    can,
    canAccessPath,
    firstAllowedPath,
    allowedModuleLabels,
  };
};

export default usePermissions;
